import { renderInDocument } from '@spotahome/soyuz/client';

import HelloWorld from './main';

renderInDocument(HelloWorld);
